
import { Component, Vue } from "vue-property-decorator";
import { IListRequest } from "@/types";
import { ListRequest } from "@/models/listRequest";

@Component({})
export default class extends Vue {
  public loading = true;

  public params: IListRequest = new ListRequest();

  public async mounted() {
    this.clear();
    this.queryToParams();

    // this.$nextTick(async function () {
    //   // searchなどのコンポーネントから値が渡ってくるのを待つ
    //   await this.getList();
    // });
  }

  public async getList(): Promise<void> {
    throw new Error("Method not implemented.");
  }

  protected clear() {
    throw new Error("Method not implemented.");
  }

  public async updateOptions(options: {
    page: number;
    itemsPerPage: number;
    sortBy: string[];
    sortDesc: boolean[];
    groupBy: string[];
    groupDesc: boolean[];
    multiSort: boolean;
    mustSort: boolean;
  }): Promise<void> {
    this.params.page = 1;
    this.params.sort_by = options.sortBy[0];
    this.params.sort_desc = options.sortDesc[0];
    this.$nextTick(async function () {
      await this.getList();
    });
  }

  // URLのパラメータをセットする
  // params -> $router
  protected paramsToQuery() {
    this.$router
      .push({
        path: this.$router.currentRoute.path,
        query: {
          search: this.params.search,
          page: this.params.page ? String(this.params.page) : "1",
          sort_by: this.params.sort_by ?? "",
          sort_desc:
            this.params.sort_desc !== undefined
              ? this.params.sort_desc.toString()
              : "",
        },
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(() => {});
  }

  // urlからパラメータをセットする
  // $router -> params
  protected queryToParams() {
    const query = this.$route.query;

    this.params.page = query.page ? Number(query.page) : 1;
    this.params.sort_by = query.sort_by
      ? decodeURI(query.sort_by as string)
      : "";
    this.params.sort_desc = query.sort_desc === "true";
  }
}
